import { useEffect } from "react"
import Cookies from "js-cookie"

const useContentfulCookie = contentful_id => {
  useEffect(() => {
    const checkForOldCookieAndRemove = Cookies.get("contentful_sid")
    if (checkForOldCookieAndRemove) {
      Cookies.remove("contentful_sid")
    }
    const cookiesLanguage = Cookies.get("contentful_id")
    // this removes current cookie that is static. This needs to be unique for all visitors
    if (
      cookiesLanguage === "2HsYdcj6svKuGU7cnAH9zn" ||
      cookiesLanguage?.includes("2HsYdcj6svKuGU7cnAH9zn")
    ) {
      Cookies.remove("contentful_id")
    } else if (cookiesLanguage && cookiesLanguage?.length >= 34) {
      const shortenString = cookiesLanguage.slice(0, 33)
      Cookies.remove("contentful_id")
      Cookies.set("contentful_id", shortenString)
    }

  }, [])
}

export default useContentfulCookie
